// Minimal, local double-submit protection for a single async action (e.g.
// one Execute button on one operation instance). This is intentionally NOT a
// request-id/sequencing system and NOT a new Redux architecture — it is a
// same-instance in-flight latch: while a call is pending, any further call is
// a no-op (`{ skipped: true }`), so a fast double click (or a double
// dispatch from any other cause) never issues the backend call twice.
//
// The backend call itself, its success/error handling, and any refetch stay
// entirely in the caller — this module only decides whether to actually
// invoke `fn` right now.
export function createSingleFlightGuard() {
  let inFlight = false;

  return {
    isRunning: () => inFlight,
    run: async (fn) => {
      if (inFlight) return { skipped: true };
      inFlight = true;
      try {
        const result = await fn();
        return { skipped: false, result };
      } finally {
        inFlight = false;
      }
    },
  };
}
